import { Component, OnInit, PLATFORM_ID, Inject, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { LinkService } from '../../_services/langhfre.service';
import { FormGroup } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformServer } from '@angular/common';
//import { environment } from 'src/environments/environment';
// import { AmplitudeService } from 'src/app/_services/amplitude.service';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  contactToSalesForm: FormGroup;
  contactForm: FormGroup;
  formSection: boolean = true;
  thankSection: boolean = false;
  country: string;

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    // public amplitudeService: AmplitudeService,
    private _renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document: Document

  ) {
  }
  email: any;

  ngOnInit() {
    this.titleService.setTitle('AI英文校正ツールTrinka |学術英語に強いAIが英文添削');
    this.metaTagService.updateTag({ name: 'description', content: '学術論文・技術文書に特化したAI英文校正ツールTrinka。文法エラーに加えて文章のトーンや文体、読みやすさも改善。AIによる英文添削でジャーナル投稿前に文章を洗練。' });
    this.metaTagService.updateTag({ name: 'keywords', content: '英文 校正,文法 チェック,英語 文法 チェック,文法 チェッカ,ー英文 チェッカー,英文 チェック,校正 英語,英文 校閲,文法 チェック 英語,英文 チェック 無料 サイト,英語 校正,英文 校正 英語,英文 チェック 無料,論文 校正,英文 校正 無料,英文 チェック サイト,英文 文法 チェック,gramamr checker, english grammar checker' });
    this.metaTagService.updateTag({ property: 'og:title', content: 'AI英文校正ツールTrinka |学術英語に強いAIが英文添削' });
    this.metaTagService.updateTag({ property: 'og:description', content: '学術論文・技術文書に特化したAI英文校正ツールTrinka。文法エラーに加えて文章のトーンや文体、読みやすさも改善。AIによる英文添削でジャーナル投稿前に文章を洗練。' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/jp/' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ja-jp' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'AI英文校正ツールTrinka |学術英語に強いAIが英文添削' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "学術論文・技術文書に特化したAI英文校正ツールTrinka。文法エラーに加えて文章のトーンや文体、読みやすさも改善。AIによる英文添削でジャーナル投稿前に文章を洗練。" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/jp/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai'});
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/' });
    // this.amplitudeService.logAmplitude('home_page_view', {});
    if (isPlatformServer(this.platformId)) {
      let script = this._renderer2.createElement('script');
      script.type = `application/ld+json`;
      script.text = `{"@context":"https://schema.org/","@type":"Product","name":"AI英文校正ツールTrinka |学術英語に強いAIが英文添削","image":"https://www.trinka.ai/assets/images/trinka_logo.svg","description":"学術論文・技術文書に特化したAI英文校正ツールTrinka。文法エラーに加えて文章のトーンや文体、読みやすさも改善。AIによる英文添削でジャーナル投稿前に文章を洗練。","brand":{"@type":"Brand","name":"Trinka"},"aggregateRating":{"@type":"AggregateRating","ratingValue":"4.9","bestRating":"5","worstRating":"2","ratingCount":"228141"}}`;

      this._renderer2.appendChild(this._document.head, script);

      let script1 = this._renderer2.createElement('script');
      script1.type = `application/ld+json`;
      script1.text = `
      {"@context":"https://schema.org/","@type":"WebSite","name":"Trinka AI Japan","url":"https://www.trinka.ai/jp","potentialAction":{"@type":"SearchAction","target":"{search_term_string}","query-input":"required name=search_term_string"}}
      `;

      this._renderer2.appendChild(this._document.head, script1);

      let script2 = this._renderer2.createElement('script');
      script2.type = `application/ld+json`;
      script2.text = `
      {"@context":"https://schema.org","@type":"SoftwareApplication","name":"AI英文校正ツールTrinka |学術英語に強いAIが英文添削","url":"https://www.trinka.ai/jp/","description":"学術論文・技術文書に特化したAI英文校正ツールTrinka。文法エラーに加えて文章のトーンや文体、読みやすさも改善。AIによる英文添削でジャーナル投稿前に文章を洗練。","applicationCategory":"WebApplication","operatingSystem":"Web"}
      `;

      this._renderer2.appendChild(this._document.head, script2);

      let script3 = this._renderer2.createElement('script');
      script3.type = `application/ld+json`;
      script3.text = `
      {"@context":"https://schema.org","@type":"FAQPage","mainEntity":[{"@type":"Question","name":"文法ミスの修正はなぜ必要なのでしょうか？","acceptedAnswer":{"@type":"Answer","text":"英文執筆において適切な文法は、英文の明瞭性、専門性、そして正確性を保証します。特に学術的・技術的な文章では、文法ミスのない正確な英語が考えを効果的に伝えるのに役立ちます。TrinkaのようなAI英文校正ツールを使えば、誤りを効率よく特定して文章を校正することができ、高い水準の文章を執筆できます。"}},{"@type":"Question","name":"オンラインで英文添削する方法は？","acceptedAnswer":{"@type":"Answer","text":"Trinka の無料オンライン文法チェッカーで、Trinkaの文法チェック機能の一端をお試しいただけます。メールアドレスのご登録でアカウントを開設いただくと、Trinka Cloud上で月に5000単語までオンラインで英文添削を行っていただけます。テキストを添削画面に貼り付けるか、対象原稿をアップロードすると、TrinkaのAIが自動的に文法、句読点、学術的なスタイルの改善点をハイライト表示し、英文添削案を提示します。"}},{"@type":"Question","name":"Microsoft Word やブラウザでも英文チェックはできますか？","acceptedAnswer":{"@type":"Answer","text":"はい。Trinka は Microsoft Word アドインとブラウザ拡張機能を提供しています。各種のプラットフォームで、文章作成中にAIがリアルタイムで英文をチェック。修正文章の候補をすぐにご確認いただけます。"}},{"@type":"Question","name":"Trinkaの英文チェックは無料ですか？","acceptedAnswer":{"@type":"Answer","text":"Trinkaのベーシックプランでは、正確な英文チェックとフォーマルなトーンを与える英文添削を月に5000単語まで無料で行っていただけます。プレミアムプランにアップグレードいただくと、毎月15万単語までの英文チェックに加えて、盗用・剽窃チェック機能、機密データプラン、Wordアドインなどのプレミアム機能にアクセスいただけるようになります。"}},{"@type":"Question","name":"Trinkaの英文校正はどんな人におすすめですか？","acceptedAnswer":{"@type":"Answer","text":"膨大な数の学術文献から学習を続けるAIを搭載したTrinkaの英文校正ツールは、フォーマルかつ技術的に正確な英語を必要とする学生、研究者、学術出版関係者、技術文書の執筆に携わるすべてのライターの方におすすめです。AIによるリアルタイムの英文校正提案を一つずつ確認いただくことでご自身のトーンを確保しつつ、正確な英文ライティングをスムーズに行っていただけます。研究論文、英語エッセイ、レポート、ビジネスコミュニケーションなど、幅広い文書の英文チェックに活用いただけます。"}},{"@type":"Question","name":"Trinkaの機密情報保護方針を教えてください","acceptedAnswer":{"@type":"Answer","text":"Trinkaでは、英文校正対象として貼り付け／アップロードされる原稿に対し、暗号化技術を使用してコンテンツの機密を保護します。また、プレミアム以上のプランをお選びいただく場合、英文チェック前後の英文の内容を、搭載するAIの学習に使用することもありません。企業・法人様には、お客様のシステム内で運用いただける「Trinkaオンプレミス」や、データの自動消去を含むより一層厳重なデータ保護プラン「機密データ保護プラン」をお選びいただくことも可能です。"}},{"@type":"Question","name":"数あるAI英文校正ツールの中でTrinkaが優れている理由は何ですか？","acceptedAnswer":{"@type":"Answer","text":"AIによるリアルタイムの英文校正、正確な英文チェック機能、校正と同じプラットフォームで使える、主要スタイルガイドに沿った原稿のフォーマッティングや盗用・剽窃チェック機能など、学術論文・技術文書の英文校正に必要な機能がTrinkaには揃っています。膨大な数の英語学術文献から学習を続けるAIを搭載したTrinkaは、アカデミックライティングに必要な、流暢でフォーマルな英語のトーンも保証。世界の研究者やライティング指導者の方にTrinkaが選ばれる理由は、こういった学術ライティングのニーズに応える多様な互換性にあります。"}},{"@type":"Question","name":"AIによる英文添削でも、英語の文章は正しく、流暢になりますか？","acceptedAnswer":{"@type":"Answer","text":"学術英語に特化して開発されたTrinkaのようなAI英文校正ツールは、英語論文・アカデミックライティングのぎこちない言い回し、冗長性、不自然な文構造を特定することで、英文の流暢さを高めます。元の英語の意味と意図を維持しながら、英語ネイティブにとってより自然な代替表現を提案し、英文の読みやすさを向上させることができます。"}},{"@type":"Question","name":"AIによる英文チェックを受ければ、人による校正は必要ないでしょうか？","acceptedAnswer":{"@type":"Answer","text":"Trinkaおよび運営元のEnagoでは、著者の皆様が使用されるツールが何であれ、使用後には必ず著者自身、あるいは専門家による英語や専門用語のチェックを行うよう推奨しています。特に生成AIを論文の執筆やパラフレーズに使用された際には、意図せぬ盗用・剽窃をおかしていないかどうかも確認が必要です。学術英語に特化したAIを搭載したTrinkaによる英文チェックは、手作業による校正の必要性を大幅に削減することができます。学術英語を書きなれている研究者の方やテクニカルライターの方にとっては、有用な代替ツールとなるでしょう。"}}]}
      `;

      this._renderer2.appendChild(this._document.head, script3);

      let script4 = this._renderer2.createElement('script');
      script4.type = `application/ld+json`;
      script4.text = `
      {"@context":"https://schema.org","@type":"Corporation","name":"AI英文校正ツールTrinka |学術英語に強いAIが英文添削","url":"https://www.trinka.ai/jp/","logo":"https://www.trinka.ai/jp/assets/images/trinka_logo.svg","sameAs":["https://www.facebook.com/thetrinkaai/","https://x.com/thetrinkaai","https://www.instagram.com/thetrinkaai/","https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA","https://www.linkedin.com/company/thetrinkaai"]}
      `;

      this._renderer2.appendChild(this._document.head, script4);

      let script5 = this._renderer2.createElement('script');
      script5.type = `application/ld+json`;
      script5.text = `
      { "@context": "https://schema.org", "@type": "Service", "name": " AI英文校正ツールTrinka |学術英語に強いAIが英文添削", "image": "https://www.trinka.ai/jp/assets/images/trinka_logo.svg", "description": "学術論文・技術文書に特化したAI英文校正ツールTrinka。文法エラーに加えて文章のトーンや文体、読みやすさも改善。AIによる英文添削でジャーナル投稿前に文章を洗練。", "provider": { "@type": "Organization", "name": "Trinka Japan", "logo": " https://www.trinka.ai/jp/assets/images/trinka_logo.svg " } } 
      `;

      this._renderer2.appendChild(this._document.head, script5);

      let script6 = this._renderer2.createElement('script');
      script6.type = `application/ld+json`;
      script6.text = `
      {"@context":"https://schema.org","@type":"Organization","name":"Trinka Japan","alternateName":"AI英文校正ツールTrinka |学術英語に強いAIが英文添削","url":"https://www.trinka.ai/jp/","logo":"https://www.trinka.ai/jp/assets/images/trinka_logo.svg","sameAs":["https://www.facebook.com/thetrinkaai/","https://x.com/thetrinkaai","https://www.instagram.com/accounts/login/?next=%2Fthetrinkaai%2F&source=omni_redirect","https://www.youtube.com/channel/UC1PNKZCxdUArpPVr5YFaYcA","https://www.linkedin.com/company/thetrinkaai"]}
      `;

      this._renderer2.appendChild(this._document.head, script6);
    }
    //ire('identify', {'customerId':'', customerEmail: '', customProfileId: this.generateGuid()});
  }
  
  activePanel: string | null = 'panel1';
  slideDir: string = '0px';

  togglePanel(el: HTMLElement, panelName: string, event: MouseEvent) {

    // Collapse if already active
    if (this.activePanel === panelName) {
      this.activePanel = null;
      return;
    }

    const rect = el.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const midPoint = rect.width / 2;

    this.slideDir = clickX < midPoint ? '-40px' : '40px';

    this.activePanel = panelName;
  }

 @ViewChild('bgVideo') bgVideo!: ElementRef<HTMLVideoElement>;
  ngAfterViewInit() {
    const video = this.bgVideo.nativeElement;
    video.muted = true;
    video.play().catch(() => {});
  }


  features = [
    {
      title: 'AI Writing Assistance',
      description: 'Academic & technical writing made easy',
      link: '/features',
      image: 'assets/images/homepage/writing-intergrity/Individuals.webp'
    },
    {
      title: 'Confidential Data Plan',
      description: 'Safe writing solution for proprietary and sensitive content',
      link: '/enterprise/confidential-data-plan-for-grammar-checker',
      image: 'assets/images/homepage/writing-intergrity/data-sensitive.webp'
    },
    {
      title: 'Academic Integrity',
      subtitle: 'For Universities',
      description: 'Responsible AI use and transparency',
      link: '/features/documark',
      image: 'assets/images/homepage/writing-intergrity/university.webp'
    }
  ]
  

}